import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from './ui/dropdown-menu';
import { Button } from './ui/button';

const ThemeToggle = () => {
  const { themeMode, resolvedTheme, changeTheme } = useTheme();

  const getIcon = () => {
    if (themeMode === 'system') return <Monitor className="w-4 h-4" />;
    return resolvedTheme === 'dark' ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />;
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid="theme-toggle-button"
          variant="outline"
          size="sm"
          className="border-white/10 bg-white/5 text-white hover:bg-white/10 rounded-xl"
        >
          {getIcon()}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-[#1a1b1f] border-white/10 text-white rounded-xl min-w-[160px]"
      >
        <DropdownMenuItem
          data-testid="theme-option-light"
          onClick={() => changeTheme('light')}
          className={`cursor-pointer rounded-lg ${themeMode === 'light' ? 'bg-gradient-to-r from-[#FF007F]/20 to-[#8A2BE2]/20' : ''}`}
        >
          <Sun className="w-4 h-4 mr-2" />
          Claro
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="theme-option-dark"
          onClick={() => changeTheme('dark')}
          className={`cursor-pointer rounded-lg ${themeMode === 'dark' ? 'bg-gradient-to-r from-[#FF007F]/20 to-[#8A2BE2]/20' : ''}`}
        >
          <Moon className="w-4 h-4 mr-2" />
          Oscuro
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="theme-option-system"
          onClick={() => changeTheme('system')}
          className={`cursor-pointer rounded-lg ${themeMode === 'system' ? 'bg-gradient-to-r from-[#FF007F]/20 to-[#8A2BE2]/20' : ''}`}
        >
          <Monitor className="w-4 h-4 mr-2" />
          Sistema
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ThemeToggle;
